import { useEffect } from 'react'

const BASE = 'Handly'

/**
 * Sets the browser tab title to `Handly · ${title}`, or just "Handly" when
 * `title` is empty/undefined (e.g. while a detail page is still loading).
 */
export function useDocumentTitle(title?: string | null) {
  useEffect(() => {
    document.title = title ? `${BASE} · ${title}` : BASE
  }, [title])
}
